import { memo, useState } from 'react';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import InputField from '../../../common/fields/InputField';
import PrimaryButton from '../../../common/buttons/PrimaryButton';
import SectionCard from './SectionCard';

const empty = { degree: '', institution: '' };

export default memo(function QualificationsSection({ qualifications, onChange }) {
  const [form, setForm] = useState(empty);
  const [showForm, setShowForm] = useState(false);

  const handleAdd = () => {
    if (!form.degree || !form.institution) return;
    onChange([...qualifications, form]);
    setForm(empty);
    setShowForm(false);
  };

  const handleRemove = (i) => onChange(qualifications.filter((_, idx) => idx !== i));

  return (
    <SectionCard title="Qualifications">
      <div className="space-y-3 mb-4">
        {qualifications.map((q, i) => (
          <div
            key={i}
            className="flex items-center justify-between bg-white/5 border border-white/10 rounded-lg px-4 py-3"
          >
            <div>
              <p className="text-white text-sm font-medium">{q.degree}</p>
              <p className="text-gray-400 text-xs">{q.institution}</p>
            </div>
            <button type="button" onClick={() => handleRemove(i)}>
              <DeleteForeverOutlinedIcon sx={{ color: '#ef4444', fontSize: 20 }} />
            </button>
          </div>
        ))}
      </div>

      {showForm ? (
        <div className="bg-white/5 border border-white/10 rounded-lg p-4 space-y-3">
          <InputField
            label="Master/Degree/Diploma"
            value={form.degree}
            onChange={(e) => setForm({ ...form, degree: e.target.value })}
          />
          <InputField
            label="Institution"
            value={form.institution}
            onChange={(e) => setForm({ ...form, institution: e.target.value })}
          />
          <div className="flex gap-2 justify-end">
            <button
              type="button"
              onClick={() => setShowForm(false)}
              className="px-4 py-2 text-sm text-gray-400 hover:text-white transition"
            >
              Cancel
            </button>
            <PrimaryButton type="button" onClick={handleAdd}>
              Add
            </PrimaryButton>
          </div>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => setShowForm(true)}
          className="w-full flex items-center justify-center gap-2 py-2.5 rounded-lg border border-dashed border-orange-500/40 text-orange-400 hover:bg-orange-500/10 transition text-sm font-medium"
        >
          <AddCircleOutlineIcon fontSize="small" /> Add Qualification
        </button>
      )}
    </SectionCard>
  );
});
